import React, { Component } from "react";
import moment from "moment";
import { observer } from "mobx-react";
import { Spin } from "antd";

import {
	Form,
	Row,
	Col,
	Button,
	DatePicker,
	TimePicker,
	Modal,
	Select,
	Divider,
	Radio,
	InputNumber
} from "antd";

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const Option = Select.Option;

@Form.create({
	mapPropsToFields(props) {
		const project = props.project;
		if (project.schedule == null) {
			return {};
		}

		var sourceProjectId = undefined;

		if (project.schedule.sourceProjectId != 0) {
			sourceProjectId = project.schedule.sourceProjectId;
		}
		let maps = {
			scheduleType: Form.createFormField({
				value: project.schedule.scheduleType
			}),
			startDate: Form.createFormField({
				value: project.schedule.startDate
					? moment.utc(project.schedule.startDate, "DD/MM/YYYY HH:mm").local()
					: null
			}),
			sourceProjectId: Form.createFormField({
				value: project.schedule.sourceProjectId
			})
		};
		maps.durationType = Form.createFormField({
			value:
				project.schedule.durationType == null
					? "Once"
					: project.schedule.durationType
		});

		maps.nDay = Form.createFormField({
			value: project.schedule.nDay
		});

		return maps;
	}
})
@observer
class AddEditScheduleForm extends Component {
	getValues = () => {
		return {
			scheduleType: this.props.form.getFieldValue("scheduleType"),
			startDate:
				this.props.form.getFieldValue("startDate") == null
					? null
					: this.props.form
							.getFieldValue("startDate")
							.utc()
							.format("DD/MM/YYYY HH:mm"),
			sourceProjectId: this.props.form.getFieldValue("sourceProjectId"),
			durationType: this.props.form.getFieldValue("durationType"),
			nDay: this.props.form.getFieldValue("nDay")
		};
	};

	onSuccess = () => {
		this.props.onSuccess();
	};

	saveSchedule = () => {
		this.validateForm((err, values) => {
			if (err) {
				return;
			}
			this.props.saveSchedule(this.getValues());
		});
	};

	validateForm = callback => {
		let scheduleType = this.props.form.getFieldValue("scheduleType");

		let durationType = this.props.form.getFieldValue("durationType");

		if (scheduleType == "FixedDate") {
			if (!durationType || durationType == "Once") {
				this.props.form.validateFieldsAndScroll(
					["startDate", "durationType"],
					callback
				);
				return;
			} else {
				if (durationType == "Spread") {
					this.props.form.validateFieldsAndScroll(
						["startDate", "durationType", "nDay"],
						callback
					);
					return;
				}
			}
		}
		if (scheduleType == "AfterProject") {
			if (!durationType || durationType == "Once") {
				this.props.form.validateFieldsAndScroll(
					["sourceProjectId", "durationType"],
					callback
				);
				return;
			} else {
				if (durationType == "Spread") {
					this.props.form.validateFieldsAndScroll(
						["sourceProjectId", "durationType", "nDay"],
						callback
					);
					return;
				}
			}
		}
	};

	render() {
		const {
			ui: { addEditScheduleDialogVisible, savingSchedule },
			hideDialog
		} = this.props;

		const tailFormItemLayout = {
			wrapperCol: {
				xs: {
					span: 24,
					offset: 0
				},
				sm: {
					span: 20,
					offset: 4
				}
			}
		};

		const formItemLayout = {
			labelCol: {
				xs: { span: 24 },
				sm: { span: 4 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 20 }
			}
		};

		const radioStyle = {
			display: "block",
			height: "30px",
			lineHeight: "30px"
		};

		const getFieldDecorator = this.props.getFieldDecorator;

		const timeFormat = "HH:mm";

		let showStartAt = "none";

		if (this.props.form.getFieldValue("scheduleType") == "FixedDate") {
			showStartAt = "block";
		}
		let startAt = (
			<div style={{ display: showStartAt }}>
				<Row gutter={8}>
					<Col span={12}>
						<FormItem label="Date">
							{this.props.form.getFieldDecorator("startDate", {
								rules: [
									{
										required: true,
										message: "Please select start date"
									}
								]
							})(<DatePicker />)}
						</FormItem>
					</Col>
					<Col span={12}>
						<FormItem label="Time">
							{this.props.form.getFieldDecorator("startDate", {
								rules: [
									{
										required: true,
										message: "Please select start time"
									}
								]
							})(<TimePicker format={timeFormat} />)}
						</FormItem>
					</Col>
				</Row>
				<br />
			</div>
		);
		let showStartAfter = "none";
		if (this.props.form.getFieldValue("scheduleType") == "AfterProject") {
			showStartAfter = "block";
		}

		let sourceProjectValidator = (rule, value, callback) => {
			if (value && value == this.props.project.id) {
				callback("Parent project must be different to the current project");
				return;
			}

			callback();
		};

		const siblings = this.props.siblings.filter(p => p.id != this.props.project.id);

		let startAfter = (
			<div style={{ display: showStartAfter }}>
				<Row>
					<Col span="24">
						<FormItem>
							{this.props.form.getFieldDecorator("sourceProjectId", {
								rules: [
									{
										required: true,
										message: "Please select a parent project"
									},
									{
										validator: sourceProjectValidator
									}
								]
							})(
								<Select style={{ width: "100%" }} placeholder="Select a project">
									{siblings.map(item => {
										return (
											<Option key={item.id} value={item.id}>
												{item.name}
											</Option>
										);
									})}
								</Select>
							)}
						</FormItem>
					</Col>
				</Row>
				<br />
			</div>
		);

		let enableNDay = false;

		if (this.props.form.getFieldValue("durationType") === "Spread") {
			enableNDay = true;
		}

		let duration = (
			<div>
				<Divider type="horizontal" orientation="left">
					Duration
				</Divider>
				<Row>
					<Col>
						<FormItem>
							{this.props.form.getFieldDecorator("durationType", {
								initialValue: "Once",
								rules: [
									{
										required: true,
										message: "Please select a duration"
									}
								]
							})(
								<RadioGroup>
									<Radio style={radioStyle} value={"Once"}>
										Run all at one time
									</Radio>
									<Radio style={radioStyle} value={"Spread"}>
										Run in
									</Radio>
									<FormItem>
										{this.props.form.getFieldDecorator("nDay", {
											rules: [
												{
													required: true,
													message: "Please choose a number of days to run"
												},
												{
													type: "integer",
													range: {
														min: 1
													},
													message: "Number of days must be greater than 0"
												}
											]
										})(<InputNumber min={1} disabled={!enableNDay} />)}
										<span className="ant-form-text">{' '}days</span>
									</FormItem>
								</RadioGroup>
							)}
						</FormItem>
					</Col>
				</Row>
			</div>
		);

		return (
			<Modal
				visible={addEditScheduleDialogVisible}
				title="Add Edit Schedule"
				okText="Create"
				onCancel={hideDialog}
				onOk={this.saveSchedule}
			>
				<Spin spinning={savingSchedule == true}>
					<Row>
						<Col span={18}>
							<FormItem {...formItemLayout}>
								{this.props.form.getFieldDecorator("scheduleType", {
									initialValue: "FixedDate",
									rules: [
										{
											required: true,
											message: "You need to select a schedule option"
										}
									]
								})(
									<RadioGroup>
										<Radio style={radioStyle} value={"FixedDate"}>
											Start at
										</Radio>
										{startAt}
										<Radio style={radioStyle} value={"AfterProject"}>
											Start after project
										</Radio>
										{startAfter}
									</RadioGroup>
								)}
							</FormItem>
						</Col>
					</Row>
					{duration}
				</Spin>
			</Modal>
		);
	}
}

@observer
class AddEditScheduleDialog extends Component {
	render() {
		const schedule = this.props.project.schedule;
		const visible = this.props.ui.addEditScheduleDialogVisible;
		return <AddEditScheduleForm {...this.props} />;
	}
}

export default AddEditScheduleDialog;
